import { Component, OnDestroy, inject, OnInit, Output, EventEmitter } from "@angular/core"
import { FormControl, FormGroup, Validators } from "@angular/forms"
import { subYears } from "date-fns"
import { CONTACT_TITLE_OPTIONS } from "src/app/meta/contact-title-options.const"
import { PATTERNS } from "src/app/meta/patterns.const"
import { CustomerDataService } from "src/app/services/customer-data.service"
import { MatchValidator } from "src/app/tools/match.validator"
import { MaxDateValidator } from "src/app/tools/max-date.validator"

@Component({
  selector: "ow-customer-data-form",
  templateUrl: "./customer-data-form.component.html"
})
export class CustomerDataFormComponent implements OnInit, OnDestroy {

  @Output() updateValidity = new EventEmitter<boolean>(false)
  
  private readonly customerDataService = inject(CustomerDataService)

  public readonly TITLE_OPTIONS = CONTACT_TITLE_OPTIONS

  public readonly form = new FormGroup({
    title: new FormControl<string>(this.customerDataService.getContactData().title, [Validators.required]),
    firstName: new FormControl<string | null>(this.customerDataService.getContactData().firstName, [
      Validators.required,
      Validators.maxLength(24)
    ]),
    lastName: new FormControl<string | null>(this.customerDataService.getContactData().lastName, [
      Validators.required,
      Validators.maxLength(24)
    ]),
    birthDate: new FormControl<Date | null>(this.customerDataService.getContactData().birthDate, [
      Validators.required,
      MaxDateValidator(subYears(new Date(), 18))
    ]),
    phoneNumber: new FormControl<string | null>(this.customerDataService.getContactData().phoneNumber, [
      Validators.required,
      Validators.pattern(PATTERNS.PHONE_NUMBER)
    ]),
    mobileNumber: new FormControl<string | null>(this.customerDataService.getContactData().mobileNumber, [
      Validators.pattern(PATTERNS.PHONE_NUMBER)
    ]),
    email: new FormControl<string | null>(this.customerDataService.getContactData().email, [
      Validators.required,
      Validators.email
    ]),
    emailConfirmation: new FormControl<string | null>(this.customerDataService.getContactData().emailConfirmation, [
      Validators.required,
      Validators.email
    ])
  })

  private readonly subscriptions = [
    this.form.controls.title.valueChanges.subscribe((value) => {
      if (this.form.controls.title.valid) {
        this.customerDataService.setContactData({ title: value! })
      }
    }),
    this.form.controls.firstName.valueChanges.subscribe((value) => {
      if (this.form.controls.firstName.valid) {
        this.customerDataService.setContactData({ firstName: value! })
      }
    }),
    this.form.controls.lastName.valueChanges.subscribe((value) => {
      if (this.form.controls.lastName.valid) {
        this.customerDataService.setContactData({ lastName: value! })
      }
    }),
    this.form.controls.birthDate.valueChanges.subscribe((value) => {
      if (this.form.controls.birthDate.valid) {
        this.customerDataService.setContactData({ birthDate: value! })
      }
    }),
    this.form.controls.phoneNumber.valueChanges.subscribe((value) => {
      if (this.form.controls.phoneNumber.valid) {
        this.customerDataService.setContactData({ phoneNumber: value! })
      }
    }),
    this.form.controls.mobileNumber.valueChanges.subscribe((value) => {
      if (this.form.controls.mobileNumber.valid) {
        this.customerDataService.setContactData({ mobileNumber: value! })
      }
    }),
    this.form.controls.email.valueChanges.subscribe((value) => {
      if (this.form.controls.email.valid) {
        this.customerDataService.setContactData({ email: value! })
      }
      this.form.controls.emailConfirmation.updateValueAndValidity()
    }),
    this.form.controls.emailConfirmation.valueChanges.subscribe((value) => {
      if (this.form.controls.emailConfirmation.valid) {
        this.customerDataService.setContactData({ emailConfirmation: value! })
      }
    }),
    this.form.statusChanges.subscribe(() => {
      this.updateValidity.emit(this.form.valid)
    })
  ]

  ngOnInit(): void {
    this.form.controls.emailConfirmation.addValidators(MatchValidator(this.form.controls.email))
    this.form.controls.emailConfirmation.updateValueAndValidity()
    this.updateValidity.emit(this.form.valid)
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }
}
